import script from "./shopCommons.vue?vue&type=script&lang=js"
export * from "./shopCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__